// @ts-nocheck
import { Component } from 'react';

class NullField extends Component {
  componentDidMount() {
    if (this.props.formData === undefined) {
      this.props.onChange(null);
    }
  }

  render() {
    return null;
  }

}

export default NullField;